import type { SVGProps } from 'react';
const SvgFlyFishing = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
    <path d="M11.407 20.946H33v-2.892h-7.577l6.537-5.13-1.846-2.276-7.42 5.786V6H19.75v10.491l-7.42-5.785-1.845 2.218 6.536 5.13h-5.614a5.16 5.16 0 0 0-3.912 1.46 4.97 4.97 0 0 0-1.486 3.843 4.97 4.97 0 0 0 1.486 3.844 5.15 5.15 0 0 0 3.912 1.46h7.852V33l9.815-7.232H11.407a2.22 2.22 0 0 1-1.826-.616 2.14 2.14 0 0 1-.627-1.795 2.14 2.14 0 0 1 .627-1.794 2.22 2.22 0 0 1 1.826-.617" />
  </svg>
);
export default SvgFlyFishing;
